import { ThemeEvents } from '@theme/events';

class ProductSizeGuide extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateGuide);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateGuide);
  }

  updateGuide = (event) => {
    const newGuide = event.detail.data.html.querySelector('product-size-guide');
    if (!newGuide) return;

    this.innerHTML = newGuide.innerHTML;
  };
}

if (!customElements.get('product-size-guide')) {
  customElements.define('product-size-guide', ProductSizeGuide);
}